export var portalPalette = {
  baseBlue: {
    hex5: "#ccecfd",
    hex10: "#99d6f8",
    hex20: "#66b8e9",
    hex30: "#3392d5",
    hex40: "#1a76bf",
    hex50: "#0055A6",
    hex60: "#004494",
    hex70: "#003383",
    hex80: "#002271",
    hex90: "#00115f",
    hex100: "#00004d"
  },
  baseBlueSky: {
    hex5: "#dffdff",
    hex10: "#bef8ff",
    hex20: "#97ebff",
    hex30: "#6dd6ff",
    hex40: "#51c2ff",
    hex50: "#33AAFF",
    hex60: "#258ae6",
    hex70: "#196dcc",
    hex80: "#0e54b3",
    hex90: "#063d99",
    hex100: "#002b80"
  },
  baseGreen: {
    hex5: "#ccfdce",
    hex10: "#99f59d",
    hex20: "#66e26b",
    hex30: "#33c539",
    hex40: "#1aa81f",
    hex50: "#008605",
    hex60: "#006304",
    hex70: "#004502",
    hex80: "#002b01",
    hex90: "#001701",
    hex100: "#000700"
  },
  baseGreenPlate: {
    hex5: "#fbfedf",
    hex10: "#f3fabd",
    hex20: "#ddef96",
    hex30: "#bedf6b",
    hex40: "#a0cf50",
    hex50: "#7CBC32",
    hex60: "#599e24",
    hex70: "#3c8118",
    hex80: "#23680e",
    hex90: "#0f5106",
    hex100: "#003d00"
  },
  baseOrange: {
    hex5: "#fffccc",
    hex10: "#fff599",
    hex20: "#ffe166",
    hex30: "#ffc333",
    hex40: "#ffa51a",
    hex50: "#FF8200",
    hex60: "#e65f00",
    hex70: "#cc4000",
    hex80: "#b32700",
    hex90: "#991200",
    hex100: "#800300"
  },
  baseRed: {
    hex5: "#fecccc",
    hex10: "#fb9999",
    hex20: "#f26666",
    hex30: "#e53333",
    hex40: "#d71a1a",
    hex50: "#C80000",
    hex60: "#aa0000",
    hex70: "#8e0000",
    hex80: "#750000",
    hex90: "#5e0000",
    hex100: "#490000"
  },
  neutrals2BlackNewBlue: {
    hex5: "#e6e7ee",
    hex10: "#e6e7ee",
    hex20: "#cecfdc",
    hex30: "#b5b7c9",
    hex40: "#9c9fb5",
    hex50: "#8387a0",
    hex60: "#6a6d88",
    hex70: "#50546f",
    hex80: "#363a53",
    hex90: "#1c1f34",
    hex100: "#000000",
    rgba5: "rgba(9, 19, 88, 0.05)",
    rgba10: "rgba(8, 18, 86, 0.1)",
    rgba20: "rgba(8, 17, 81, 0.2)",
    rgba30: "rgba(7, 16, 75, 0.3)",
    rgba40: "rgba(7, 15, 70, 0.4)",
    rgba50: "rgba(6, 14, 64, 0.5)",
    rgba60: "rgba(6, 12, 57, 0.6)",
    rgba70: "rgba(5, 11, 49, 0.7)",
    rgba80: "rgba(4, 9, 40, 0.8)",
    rgba90: "rgba(3, 6, 29, 0.9)",
    rgba100: "rgb(0, 0, 0)"
  },
  neutrals2BlackOldBlue: {
    hex5: "#e6eaee",
    hex10: "#e6eaed",
    hex20: "#ccd4db",
    hex30: "#b3bdc7",
    hex40: "#99a6b3",
    hex50: "#808f9d",
    hex60: "#667685",
    hex70: "#4d5d6c",
    hex80: "#334251",
    hex90: "#1a2531",
    hex100: "#000000",
    rgba5: "rgba(0, 41, 81, 0.05)",
    rgba10: "rgba(0, 40, 79, 0.1)",
    rgba20: "rgba(0, 38, 74, 0.2)",
    rgba30: "rgba(0, 36, 69, 0.3)",
    rgba40: "rgba(0, 33, 64, 0.4)",
    rgba50: "rgba(0, 30, 59, 0.5)",
    rgba60: "rgba(0, 27, 52, 0.6)",
    rgba70: "rgba(0, 23, 45, 0.7)",
    rgba80: "rgba(0, 19, 37, 0.8)",
    rgba90: "rgba(0, 13, 26, 0.9)",
    rgba100: "rgb(0, 0, 0)"
  },
  neutrals2BlackOldBlueSky: {
    hex5: "#e8eef2",
    hex10: "#e8eef2",
    hex20: "#d1dbe3",
    hex30: "#b9c8d3",
    hex40: "#a1b3c1",
    hex50: "#899ead",
    hex60: "#708697",
    hex70: "#566d7e",
    hex80: "#3c5161",
    hex90: "#21323e",
    hex100: "#000000",
    rgba5: "rgba(25, 83, 124, 0.05)",
    rgba10: "rgba(24, 81, 121, 0.1)",
    rgba20: "rgba(23, 76, 114, 0.2)",
    rgba30: "rgba(21, 71, 107, 0.3)",
    rgba40: "rgba(20, 66, 99, 0.4)",
    rgba50: "rgba(18, 60, 90, 0.5)",
    rgba60: "rgba(16, 54, 81, 0.6)",
    rgba70: "rgba(14, 47, 70, 0.7)",
    rgba80: "rgba(11, 38, 57, 0.8)",
    rgba90: "rgba(8, 27, 40, 0.9)",
    rgba100: "rgb(0, 0, 0)"
  },
  neutrals2BlackOrig: {
    hex5: "#e6e6e6",
    hex10: "#e6e6e6",
    hex20: "#cccccc",
    hex30: "#b3b3b3",
    hex40: "#999999",
    hex50: "#808080",
    hex60: "#666666",
    hex70: "#4d4d4d",
    hex80: "#333333",
    hex90: "#1a1a1a",
    hex100: "#000000",
    rgba5: "rgba(0, 0, 0, 0.05)",
    rgba10: "rgba(0, 0, 0, 0.1)",
    rgba20: "rgba(0, 0, 0, 0.2)",
    rgba30: "rgba(0, 0, 0, 0.3)",
    rgba40: "rgba(0, 0, 0, 0.4)",
    rgba50: "rgba(0, 0, 0, 0.5)",
    rgba60: "rgba(0, 0, 0, 0.6)",
    rgba70: "rgba(0, 0, 0, 0.7)",
    rgba80: "rgba(0, 0, 0, 0.8)",
    rgba90: "rgba(0, 0, 0, 0.9)",
    rgba100: "rgb(0, 0, 0)"
  },
  neutralsBlack: {
    hex5: "#f2f5ff",
    hex8: "#edefff",
    hex10: "#e6e8fb",
    hex15: "#d9d9ef",
    hex20: "#cccdeb",
    hex30: "#b3b7d8",
    hex40: "#999dbe",
    hex50: "#7f85a6",
    hex60: "#666c91",
    hex70: "#4d5376",
    hex80: "#33395b",
    hex90: "#1b213a",
    hex100: "#0f1224",
    rgba5: "rgba(0, 56, 255, 0.05)",
    rgba8: "rgba(30, 52, 248, 0.08)",
    rgba10: "rgba(5, 23, 210, 0.1)",
    rgba15: "rgba(3, 0, 143, 0.15)",
    rgba20: "rgba(0, 6, 153, 0.2)",
    rgba30: "rgba(0, 12, 123, 0.3)",
    rgba40: "rgba(0, 9, 92, 0.4)",
    rgba50: "rgba(1, 13, 78, 0.5)",
    rgba60: "rgba(0, 10, 72, 0.6)",
    rgba70: "rgba(0, 9, 58, 0.7)",
    rgba80: "rgba(0, 8, 50, 0.8)",
    rgba90: "rgba(1, 8, 36, 0.9)",
    rgba100: "rgb(15, 18, 36)"
  },
  neutralsWhite: {
    hex5: "#ffffff",
    hex10: "#ffffff",
    hex20: "#ffffff",
    hex30: "#ffffff",
    hex40: "#ffffff",
    hex50: "#ffffff",
    hex60: "#ffffff",
    hex70: "#ffffff",
    hex80: "#ffffff",
    hex90: "#ffffff",
    hex100: "#ffffff",
    rgba5: "rgba(255, 255, 255, 0.05)",
    rgba10: "rgba(255, 255, 255, 0.1)",
    rgba20: "rgba(255, 255, 255, 0.2)",
    rgba30: "rgba(255, 255, 255, 0.3)",
    rgba40: "rgba(255, 255, 255, 0.4)",
    rgba50: "rgba(255, 255, 255, 0.5)",
    rgba60: "rgba(255, 255, 255, 0.6)",
    rgba70: "rgba(255, 255, 255, 0.7)",
    rgba80: "rgba(255, 255, 255, 0.8)",
    rgba90: "rgba(255, 255, 255, 0.9)",
    rgba100: "rgb(255, 255, 255)"
  },
  newBlue: {
    hex5: "#d5e1ff",
    hex10: "#abc1ff",
    hex20: "#7e9bff",
    hex30: "#4f71ff",
    hex40: "#3555ff",
    hex50: "#1937FF",
    hex60: "#1228e6",
    hex70: "#0c1acc",
    hex80: "#070fb3",
    hex90: "#030799",
    hex100: "#000080"
  },
  newBlueDark: {
    hex5: "#d5dbfe",
    hex10: "#abb6fc",
    hex20: "#7e8cf7",
    hex30: "#4f60ee",
    hex40: "#3545e6",
    hex50: "#1928DC",
    hex60: "#121dc0",
    hex70: "#0c13a5",
    hex80: "#070b8c",
    hex90: "#030573",
    hex100: "#00005d"
  },
  newBlueLight: {
    hex5: "#ccfcff",
    hex10: "#99f5ff",
    hex20: "#66e1ff",
    hex30: "#33c3ff",
    hex40: "#1aa4ff",
    hex50: "#0081FF",
    hex60: "#005ee6",
    hex70: "#003fcc",
    hex80: "#0025b3",
    hex90: "#001199",
    hex100: "#000280"
  },
  newOrange: {
    hex5: "#ffeecc",
    hex10: "#ffda99",
    hex20: "#ffbc66",
    hex30: "#ff9833",
    hex40: "#ff7b1a",
    hex50: "#FF5A00",
    hex60: "#e64100",
    hex70: "#cc2b00",
    hex80: "#b31900",
    hex90: "#990b00",
    hex100: "#800000"
  },
  newOrangeDark: {
    hex5: "#fffccc",
    hex10: "#fff599",
    hex20: "#ffe166",
    hex30: "#ffc333",
    hex40: "#ffa51a",
    hex50: "#FF8200",
    hex60: "#e65f00",
    hex70: "#cc4000",
    hex80: "#b32700",
    hex90: "#991200",
    hex100: "#800300"
  },
  newOrangeLight: {
    hex5: "#fffdd4",
    hex10: "#fff8a7",
    hex20: "#ffeb79",
    hex30: "#ffd649",
    hex40: "#ffc230",
    hex50: "#FFAA14",
    hex60: "#e68a0e",
    hex70: "#cc6d0a",
    hex80: "#b35406",
    hex90: "#993d02",
    hex100: "#802b00"
  },
  newRed: {
    hex5: "#ffdfe5",
    hex10: "#fdbdc8",
    hex20: "#fa96a4",
    hex30: "#f46b7c",
    hex40: "#ef5060",
    hex50: "#E83241",
    hex60: "#cd242f",
    hex70: "#b2181f",
    hex80: "#990e12",
    hex90: "#800608",
    hex100: "#690000"
  },
  newGreen: {
    hex5: "#dafde0",
    hex10: "#b4f8bf",
    hex20: "#89e899",
    hex30: "#5dd26e",
    hex40: "#42bc53",
    hex50: "#25a135",
    hex60: "#1b8026",
    hex70: "#12631a",
    hex80: "#0b4a0f",
    hex90: "#053407",
    hex100: "#002200"
  },
  newViolet: {
    hex5: "#f7e4fd",
    hex10: "#ebc7f8",
    hex20: "#d3a3e9",
    hex30: "#b27bd3",
    hex40: "#945fbd",
    hex50: "#7140A2",
    hex60: "#512e81",
    hex70: "#361f64",
    hex80: "#20124a",
    hex90: "#0e0835",
    hex100: "#000023"
  },
  transparent: "rgba(0, 0, 0, 0)"
};